import { gql } from 'application/providers/DataProvider';

export const STREAM_SET_WITH_THEMATIC_CONTENT_QUERY = gql`
  query streamSetWithThematicContent @client {
    withThematic
  }
`;
